import { ResponseRowByOrderType } from 'apiConnector/secondary-market/batch/model';
import { OrderTypeState, Row, SubStateContentByOrderType } from 'state/workspaces/secondary-market/batch/model';
import { LoadingStatus, SuccessContent } from 'utils/status';

export function asSuccessByOrderType(state: OrderTypeState): SuccessContent<SubStateContentByOrderType> | undefined {
  return state.status === 'success' ? state : undefined;
}

export function replaceRowsById(
  rows: Row[],
  incomingRows: readonly ResponseRowByOrderType[],
  modifyStatus?: LoadingStatus,
): Row[] {
  return rows.map(row => {
    const incoming = incomingRows.find(incomingRow => incomingRow.data.rowId === row.data.rowId);
    if (!incoming) {
      return row;
    }

    return {
      ...row,
      data: {
        ...incoming.data,
        metadata: {
          ...incoming.metadata,
          endZonedDateTimeToTrade: Temporal.Now.zonedDateTimeISO()
            .add({ seconds: incoming.metadata.timeToTradeInSeconds ?? 0 })
            .toString(),
        },
        modifyStatus: modifyStatus ?? row.data.modifyStatus,
      },
    };
  });
}
